import {Pipe, PipeTransform} from '@angular/core';
import {UnitAdvertisementDto} from "homey-housing-lottery-app-dto";

@Pipe({
  name: 'maxHouseholdSize',
  standalone: true
})
export class MaxHouseholdSizePipe implements PipeTransform {
  transform(advertisements: UnitAdvertisementDto[]): number {
    return Math.max(...advertisements.map(advertisement => advertisement.householdSize));
  }
}
